<template>
	<form @submit.prevent="onSubmit" novalidate>
		<slot :meta="meta" :submitting="submitting" :success="success" :error="error"></slot>
	</form>
</template>

<script setup>
import { ref } from 'vue';
import { useForm } from 'vee-validate';
import { useFormspark } from "@formspark/vue-use-formspark";

const { meta, handleSubmit, resetForm } = useForm();

const [submit, submitting] = useFormspark({
	formId: "1FVhlpBkG"
});

const success = ref(false);
const error = ref(false);

const onSubmit = handleSubmit(async values => {
	success.value = false;
	error.value = false;
	try {
		await submit(values);
		success.value = true;
		plausible('Quote Requested')
		resetForm();
	} catch (err) {
		error.value = true;
		plausible('Quote Request Failed')
		console.error(err.message || 'An error occurred during submission');
	}
});
</script>
